module.exports = __webpack_public_path__ + "static/media/fast-forward.b84262ba.svg";